var React = require('react');

function Train (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M0 0h24v24H0z","key":0}),React.createElement("path",{"fill":"#757575","fillRule":"nonzero","d":"M4 15.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V5c0-3.5-3.58-4-8-4s-8 .5-8 4v10.5zm8 1.5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6-7H6V5h12v5z","key":1})]));
}

Train.displayName = "Train";

Train.defaultProps = {"width":"24","height":"24"};

module.exports = Train;

Train.default = Train;



// WEBPACK FOOTER //
// ./src/images/icons/train.svg